// import React from "react";

// const AboutSection = () => {
//   return (
//     <section className="bg-[#f9f6f1] py-16 px-6 md:px-16">
//       <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-center">
//         {/* Left Text Section */}
//         <div>
//           <h2 className="text-4xl md:text-5xl font-light text-gray-800 mb-2">
//             We Are <span className="font-semibold">Bakelore</span>
//           </h2>
//           <h3 className="text-3xl md:text-4xl font-semibold text-gray-800 mb-8">
//             WE LOVE CAKE
//           </h3>

//           <p className="text-gray-600 leading-relaxed mb-4">
//             Bakelore was founded with the aim of bringing scrumpdillylicious
//             traditional baked goods to modern-day customers. We believe that
//             good food should be made with the finest ingredients and from the
//             finest memories of the ‘90s with our families.
//           </p>
//           <p className="text-gray-600 leading-relaxed mb-4">
//             We are passionate about bringing former-time delicacies by
//             inculcating our recipes with nostalgic flavors and combinations.
//             Bakelore strives to create an atmosphere that is warm and welcoming,
//             which is why nostalgia is set as the core theme to bring good food
//             and good memories from the past together.
//           </p>
//           <p className="text-gray-600 leading-relaxed mb-8">
//             We hope that Bakelore becomes a place where you come to enjoy
//             delicious food and reminisce memories with friends and family.
//           </p>

//           <button className="bg-[#d49393] hover:bg-[#c37c7c] text-white font-medium py-3 px-8 rounded-sm transition-all duration-300">
//             SHOP NOW
//           </button>
//         </div>

//         {/* Right Image Section */}
//         <div className="w-full">
//           <img
//             src="http://bakelore.com/images/Bakelore_Store-7-min.webp" // 🔹 Replace with your image path
//             alt="Bakelore interior"
//             className="w-full h-auto rounded-md shadow-md object-cover"
//           />
//         </div>
//       </div>
//     </section>
//   );
// };

// export default AboutSection;

import React from "react";
import { Link } from "react-router-dom";

const AboutSection = () => {
  return (
    <section className="bg-[#f9f6f1] py-16 px-6 md:px-16 font-body">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-center">
        {/* Left Text Section */}
        <div>
          {/* Headings use Marcellus */}
          <h2 className="text-4xl md:text-5xl font-heading text-gray-800 mb-2 tracking-wide">
            <span className="text-[#C08B89]">Bakelore</span>
          </h2>
          <h3 className="text-3xl md:text-4xl font-heading text-gray-800 mb-8 uppercase tracking-wider">
            A Bite of Good Old Days
          </h3>

          {/* Paragraphs use Manrope */}
          <p className="text-gray-600 leading-relaxed mb-4">
            Bakelore was founded with the aim of bringing scrumpdillylicious
            traditional baked goods to modern-day customers. We believe that
            good food should be made with the finest ingredients and from the
            finest memories of the ‘90s with our families.
          </p>
          <p className="text-gray-600 leading-relaxed mb-4">
            We are passionate about bringing former-time delicacies by
            inculcating our recipes with nostalgic flavors and combinations.
            Bakelore strives to create an atmosphere that is warm and welcoming,
            which is why nostalgia is set as the core theme to bring good food
            and good memories from the past together.
          </p>
          <p className="text-gray-600 leading-relaxed mb-8">
            We hope that Bakelore becomes a place where you come to enjoy
            delicious food and reminisce memories with friends and family.
          </p>

          {/* Button */}
          <Link to="#">
            <button className="bg-[#C08B89] hover:bg-[#a66e67] text-white font-medium py-3 px-10 rounded-md transition-all duration-300 shadow-sm">
              SHOP NOW
            </button>
          </Link>
        </div>

        {/* Right Image Section */}
        <div className="w-full">
          <img
            src="http://bakelore.com/images/Bakelore_Store-7-min.webp"
            alt="Bakelore interior"
            className="w-full h-auto rounded-md shadow-md object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
